import { createFileRoute, useParams } from "@tanstack/react-router";
import { OpportunityDetailPage } from "@/components/crm/OpportunityDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/opportunities_/$id")({
  component: AdminOpportunityDetail,
});

function AdminOpportunityDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/opportunities_/$id" });
  return <OpportunityDetailPage opportunityId={id} role="admin" />;
}
